const category = [
  { name: "", id: "32d60762-c19f-4ba6-b1f7-962437428886" },
  { name: "Bills", id: "125ce384-817b-4c04-ac2c-6e07d298b3a7" },
  { name: "Work", id: "1c641527-53eb-4fd8-be44-8152aca5429a" },
  { name: "Food", id: "b144f24a-d43c-4ad5-aad1-0dd676724876" },
  { name: "Hobby", id: "9c235b6f-3ef9-43c4-9a27-afa16e374382" },
  { name: "Holiday", id: "37292a14-f7c0-4132-a1a7-8300eeb55457" },
  { name: "Other", id: "11d23521-cc31-421c-9de8-20b3f2109514" }
];
export default category;
